import utilities from '../assets/scripts/utilities';
import { EVENT_MESSAGES, EVENT_TYPES, LOGGING_CONSTANTS } from '../static/global-variables';
import store from '../stores/index';

const formJson = function formDefaultLoggingBody(signinId, language, eventType, zoom_message, success = null, status = null) {
    const loggingBody = {
        signinId: signinId,
        event_type: eventType,
        browser_type: utilities.getBrowserName(),
        viewport_browser_res: utilities.getViewportBrowserRes(),
        zoom_message: zoom_message,
        client_app_name: LOGGING_CONSTANTS.APP_NAME,
        client_language: language,
        client_uuid: store.getters.uuid
    }
    if (success) {
        loggingBody.success = success;
    }
    if (status) {
        loggingBody.status = status;
    }
    return loggingBody;
}

const formSocketJson = function formSocketLoggingBody(channelId, uuid, eventType, zoom_message, success = null, status = null) {
    const loggingBody = {
        channelId: channelId,
        uuid: uuid,
        event_type: eventType,
        browser_type: utilities.getBrowserName(),
        viewport_browser_res: utilities.getViewportBrowserRes(),
        zoom_message: zoom_message,
        client_app_name: LOGGING_CONSTANTS.APP_NAME,
        client_uuid: store.getters.uuid
    }
    if (success) {
        loggingBody.success = success;
    }
    if (status) {
        loggingBody.status = status;
    }
    return loggingBody;
}

const formLogData = {
    formSignatureGet: function(signinId, language, success, status, zoom_message) {
        return formJson(signinId, language, EVENT_TYPES.SIGNATURE_REVIEW_GET, zoom_message, status, success);
    },
    formSignaturePost: function(signinId, language, success, status, zoom_message) {
        return formJson(signinId, language, EVENT_TYPES.SIGNATURE_REVIEW_POST, zoom_message, status, success);
    },
    formSignatureLarge: function(signinId, language) {
        return formJson(signinId, language, EVENT_TYPES.SIGNATURE_SIZE_LARGE, EVENT_MESSAGES.SIGNATURE_SIZE_LARGE.replace('{0}', signinId));
    },
    formSignatureLoad: function(signinId, language) {
        return formJson(signinId, language, EVENT_TYPES.SIGNATURE_PAGE_LOAD, EVENT_MESSAGES.SIGNATURE_PAGE_LOAD.replace('{0}', signinId));
    },
    formSignatureExit: function(signinId, language) {
        return formJson(signinId, language, EVENT_TYPES.SIGNATURE_PAGE_EXIT, EVENT_MESSAGES.SIGNATURE_PAGE_EXIT.replace('{0}', signinId));
    },
    formStompError: function(channelId, uuid, errorMessage) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.ERROR_WEB_SOCKET, EVENT_MESSAGES.SOCKET_STOMP_ERROR.replace('{0}', channelId).replace('{1}', uuid).replace('{2}', errorMessage));
    },
    formSubscribeSuccess: function(channelId, uuid, endPoint) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_SUBSCRIBE, EVENT_MESSAGES.SOCKET_SUBSCRIBE_SUCCESS.replace('{0}', channelId).replace('{1}', uuid).replace('{2}', endPoint), true);
    },
    formSubscribeError: function(channelId, uuid, endPoint) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_SUBSCRIBE, EVENT_MESSAGES.SOCKET_SUBSCRIBE_ERROR.replace('{0}', channelId).replace('{1}', uuid).replace('{2}', endPoint), false);
    },
    formSocketConnectSuccess: function(channelId, uuid) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_CONNECT, EVENT_MESSAGES.SOCKET_CONNECT_SUCCESS.replace('{0}', channelId).replace('{1}', uuid), true);
    },
    formSocketConnectError: function(channelId, uuid) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_CONNECT, EVENT_MESSAGES.SOCKET_CONNECT_ERROR.replace('{0}', channelId).replace('{1}', uuid), false);
    },
    formSocketMessageReceipt: function(channelId, uuid, message, endPoint) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_MESSAGE, EVENT_MESSAGES.SOCKET_MESSAGE.replace('{0}', channelId).replace('{1}', uuid).replace('{2}', message).replace('{3}', endPoint))
    },
    formSocketDisconnect: function(channelId, uuid) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_DISCONNECT, EVENT_MESSAGES.SOCKET_DISCONNECT.replace('{0}', channelId).replace('{1}', uuid));
    },
    formSocketDeactivate: function(channelId, uuid) {
        return formSocketJson(channelId, uuid, EVENT_TYPES.SOCKET_DEACTIVATE, EVENT_MESSAGES.SOCKET_DEACTIVATE.replace('{0}', channelId).replace('{1}', uuid));
    }

}

export default formLogData;
